<script setup>
import { computed, defineProps } from 'vue';
import { useStore } from 'vuex'

const userRoles = computed(() => JSON.parse(localStorage.getItem('roles')));
const roleExist = (slug) => {
  if (userRoles.value && userRoles.value.length) {
      return userRoles.value.some((obj) => (obj.slug === slug));
  }

  return false;
}

const props = defineProps({
   lto_record: {
    type: Object,
    required: true
   } 
});

const store = useStore();

const loading = computed(() => store.state.globals.loading);
</script>

<template>
<b-overlay :show="loading">
    <div class="row m-3">
        <table class="table table-bordered table-sm table-light m-0">
            <tbody>
                <tr>
                    <th colspan="2" class="text-center">LTO Record</th>
                </tr>
                <tr>
                    <td class="no-wrap">Plate No.</td>
                    <td>{{ props.lto_record.plate_number ? props.lto_record.plate_number : 'n/a' }}</td>
                </tr>
                <tr>
                    <td class="no-wrap">MV File No.</td>
                    <td>{{ props.lto_record.mv_file_number ? props.lto_record.mv_file_number : 'n/a' }}</td>
                </tr>
                <tr>
                    <td class="no-wrap">Series</td>
                    <td>{{ props.lto_record.series ? props.lto_record.series : 'n/a'}}</td>
                </tr>
                <tr>
                    <td class="no-wrap">Year Model</td>
                    <td>{{ props.lto_record.year_model ? props.lto_record.year_model : 'n/a'}}</td>

                </tr>
                <tr>
                    <td class="no-wrap">Classification</td>
                    <td>{{ props.lto_record.classification ? props.lto_record.classification : 'n/a'}}</td>

                </tr>
                <tr>
                    <td class="no-wrap">Body Type</td>
                    <td>{{ props.lto_record.body_type ? props.lto_record.body_type : 'n/a'}}</td>
                </tr>
                <tr v-if="roleExist('lto-record')">
                    <td class="no-wrap">Owner Address</td>
                    <td>{{ props.lto_record.owner_address ? props.lto_record.owner_address : 'n/a'}}</td>
                </tr>
                <tr v-if="props.lto_record.city">
                    <td class="no-wrap">City</td>
                    <td>{{ props.lto_record.city ? props.lto_record.city : 'n/a'}}</td>
                </tr>
                 <tr>
                    <td class="no-wrap">Make</td>
                    <td>{{ props.lto_record.make ? props.lto_record.make : 'n/a'}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</b-overlay>
</template>

<style scoped>
.no-wrap{
  min-width: fit-content;
  width: 100px;
  white-space: nowrap;
}
th, td {
    background-color: #fff;
}
td{
  padding: 5px;
  text-align: center;
}
</style>
